import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router';
import Button from '@mui/material/Button';
const Page404Container = styled.div `
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const Delim = styled.div `
  margin-top: 30px;
`;
const Text = styled.div `
  font-size: 5rem;
`;
export function Page404() {
    const nav = useNavigate();
    const onClick = () => {
        nav('/');
    };
    useEffect(() => {
        const id = setTimeout(() => onClick(), 5000);
        return () => clearTimeout(id);
    }, []);
    return (_jsxs(Page404Container, { children: [_jsx(Text, { children: "\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u0430" }), _jsx(Delim, {}), _jsx(Button, Object.assign({ sx: { width: '200px' }, onClick: onClick }, { children: "\u041D\u0430 \u0433\u043B\u0430\u0432\u043D\u0443\u044E" }))] }));
}
